module.exports = __webpack_public_path__ + "static/nespresso-banner-375-29ef684a906d47bb94864f0c23eb1705.jpg";